import Notice from '@/pages/notice'

export default [
    {
        path: '/notice',
        name: '消息中心',
        component: Notice,
        invisible: false
    }
]


// WEBPACK FOOTER //
// ./src/router/notice.js